import { getEssayByUser } from '../../../core/queries/essays-queries/essayFunction';
import { useGenericQuery } from '../../../core/api/reactQuery';
import { IEssay } from '../../../core/models/essay';

export function useGetUserPracticeEssay(slug:string, cb: (body: IEssay) => void) {
  const {
    data,
    isError,
    error,
    isPending
  } = useGenericQuery(['userPracticeEssay', slug], () => getEssayByUser(slug), cb);

  return {
    isError,
    isPending,
    error,
    data
  }
}
